export default __webpack_public_path__ + "static/media/kitchen4-afterF-2048w.8c439cb6.webp";